import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { PublicLayout } from "@/components/PublicLayout";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import Properties from "@/pages/Properties";
import PropertyDetail from "@/pages/PropertyDetail";
import ShortStay from "@/pages/ShortStay";
import Investir from "@/pages/Investir";
import Gestion from "@/pages/Gestion";
import Conciergerie from "@/pages/Conciergerie";
import Diaspora from "@/pages/Diaspora";
import Projects from "@/pages/Projects";
import About from "@/pages/About";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import ClientDashboard from "@/pages/dashboard/ClientDashboard";
import OwnerDashboard from "@/pages/dashboard/OwnerDashboard";
import PartnerDashboard from "@/pages/dashboard/PartnerDashboard";
import AdminDashboard from "@/pages/dashboard/AdminDashboard";

const STAFF = ["admin", "agent", "gestionnaire", "concierge"];

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/acheter" element={<Properties transaction="vente" heroEyebrow="Acheter" heroTitle="Biens à vendre" heroSubtitle="Trouvez le bien qui correspond à vos ambitions patrimoniales." />} />
        <Route path="/louer" element={<Properties transaction="location" heroEyebrow="Louer" heroTitle="Biens à louer" heroSubtitle="Des locations d'exception, prêtes à vous accueillir." />} />
        <Route path="/investir" element={<Investir />} />
        <Route path="/gestion" element={<Gestion />} />
        <Route path="/conciergerie" element={<Conciergerie />} />
        <Route path="/location-courte-duree" element={<ShortStay />} />
        <Route path="/diaspora" element={<Diaspora />} />
        <Route path="/nos-projets" element={<Projects />} />
        <Route path="/a-propos" element={<About />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/politique-confidentialite" element={<Privacy />} />
        <Route path="/termes-conditions" element={<Terms />} />
        <Route path="/bien/:id" element={<PropertyDetail />} />
      </Route>

      <Route path="/login" element={<Login />} />
      <Route path="/inscription" element={<Register />} />
      <Route path="/espace-client" element={<ProtectedRoute><ClientDashboard /></ProtectedRoute>} />
      <Route path="/espace-proprietaire" element={<ProtectedRoute roles={["owner"]}><OwnerDashboard /></ProtectedRoute>} />
      <Route path="/espace-partenaire" element={<ProtectedRoute roles={["partenaire"]}><PartnerDashboard /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute roles={STAFF}><AdminDashboard /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <LanguageProvider>
            <AppRoutes />
            <Toaster position="top-right" richColors />
          </LanguageProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
